import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full mb-4"
}
const _hoisted_2 = { class: "relative flex items-center w-full h-[22px] max-h-[22px] bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex flex-wrap items-start w-full justify-center gap-x-1" }
const _hoisted_5 = ["onClick", "onMouseover"]
const _hoisted_6 = ["src", "srcset"]
const _hoisted_7 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-12 mx-auto text-center mt-1" }
const _hoisted_8 = { class: "text-parameter-title text-[10px] overflow-hidden max-w-12 mx-auto text-center mt-1" }
const _hoisted_9 = { class: "flex flex-wrap items-start w-full justify-center gap-x-1" }
const _hoisted_10 = ["onClick", "onMouseover"]
const _hoisted_11 = ["src", "srcset"]
const _hoisted_12 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-12 mx-auto text-center mt-1" }
const _hoisted_13 = { class: "text-parameter-title text-[10px] overflow-hidden max-w-12 mx-auto text-center mt-1" }

import ItemV3ParameterBox from "@/components/itemV3/parameter/itemV3ParameterBox.vue";
import ItemV3MostSelected from "@/components/itemV3/parameter/itemV3MostSelected.vue";
import {computed, inject, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import {getCurrentText} from "@/assets/ts/itemText";

const imageWidthPercent: number = 30
const boxIdx = "metal"

const variantIdx = "discs.*.metal"

const focusValueIdxCount = 5


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3DiscsMetal',
  props: ["item"],
  emits: ["patch"],
  setup(__props, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;
const props = __props;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

const loading = ref(true)

/**
 * Parameter box header images
 */

const mainMetal = computed(() => store.getters["session/getMainMetal"])
const getHeaderImage = (size: string = "600x300", withBg = false) => {
  if (withBg) {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${mainMetal.value}_${boxIdx}.webp`
  } else {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${boxIdx}.webp`
  }
}

/**
 * session
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

const currentDiscsMetalText = computed(() => {
  return getCurrentText(configureAll.value ? -1 : itemIdx.value, variantIdx)
})

const open = ref(false)

const discVariants = computed(() => open.value ? parametersVariations.getVariants() : [])

/**
 * color variants
 */

const activeDiscIdx = ref(0)

const discSliderStyle = computed(() => {
  const count = discVariants.value.length;
  if (count === 0 || activeDiscIdx.value < 0 || activeDiscIdx.value >= count) return {display: 'none'};

  const width = 100 / count;
  const left = activeDiscIdx.value * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
});

const finishVariantsOfDisc = computed(() => {
  if (!discVariants.value.length || discVariants.value.length < activeDiscIdx.value) return []
  return discVariants.value[activeDiscIdx.value].values
})

const activeDisc = computed(() => {
  if (!discVariants.value.length || discVariants.value.length < activeDiscIdx.value) return []
  return discVariants.value[activeDiscIdx.value]
})

const matchedDiscIdx = computed(() => {
  if (!discVariants.value.length || discVariants.value.length < activeDiscIdx.value) return -1
  return discVariants.value[activeDiscIdx.value].values.findIndex((v: any) => v.match)
})

const matchedDisc = computed(() => {
  if (!discVariants.value.length || discVariants.value.length < activeDiscIdx.value) return -1
  return discVariants.value[activeDiscIdx.value].values.find((v: any) => v.match)
})

/**
 * image
 */

const hoverIdx = ref("")
const hoverColor = ref("")

const setHoverIdx = () => {
  if (matchedDiscIdx.value !== -1 && finishVariantsOfDisc.value.length >= matchedDiscIdx.value) {
    hoverIdx.value = matchedDisc.value.idx
    hoverColor.value = matchedDisc.value.additional_value
  }
}

watch(activeDisc, () => {
  setHoverIdx()
})

watch(props.item, () => {
  setHoverIdx()
})

const imageUrl = computed(() => parametersVariations.imageUrl(finishVariantsOfDisc.value, finishVariantsOfDisc.value.findIndex((disc: any) => disc.idx === hoverIdx.value).value))

const getFinishImageUrl = (finish: string, color: string, sizeX: number, sizeY: number) => {
  return 'https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/finishes/' + sizeX + 'x' + sizeY + '/' + finish.toLowerCase() + '_' + color.toLowerCase() + '.webp'
}

const checkImageLoaded = (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(true);
    img.src = url;
  });
};

const checkAllLoaded = async () => {
  const discs = discVariants.value;
  if (!discs.length) return;

  const allListsCreated = discs.every((disc: any) => disc.values && disc.values.length > 0);
  if (!allListsCreated) return;

  const imageUrls = discs.flatMap((disc: any) => disc.values.map((color: any) => getFinishImageUrl(color.idx, color.additional_value, 400, 300)));
  await Promise.all(imageUrls.map((url: string) => checkImageLoaded(url)));

  loading.value = false;
};

watch(discVariants, () => {
  checkAllLoaded();
  if (discVariants.value.length > 0) {
    loading.value = true;
  }
}, {immediate: true, deep: true});

/*
 * focus values
 */

const focusValueIdx: { [key: string]: string[] } = {
  "YELLOW":
      [
        "AU333",
        "AU375",
        "AU585",
        "AU750",
        "AU916"
      ],
  "RED":
      [
        "AU333",
        "AU375",
        "AU585",
        "AU750"
      ],
  "ROSE":
      [
        "AU333",
        "AU375",
        "AU585",
        "AU750"
      ],
  "PEACH":
      [
        "AU333",
        "AU375",
        "AU585",
        "AU750"
      ],
  "WHITE":
      [
        "AU333",
        "AU585",
        "AU750",
        "PT600",
        "PT950"
      ],
  "GRAY":
      [
        "AU333",
        "AU585",
        "AU750",
        "PT600",
        "PT950"
      ]
}

const focusAltValueIdx: { [key: string]: string[] } = {
  "YELLOW":
      [
        "PT950"
      ],
  "RED":
      [
        "PT950",
        "PT600"
      ],
  "ROSE":
      [
        "PT950",
        "PT600"
      ],
  "PEACH":
      [
        "PT950",
        "PT600"
      ],
  "WHITE":
      [
        "AU375",
        "AG925"
      ],
  "GRAY":
      [
        "AU375",
        "AG925"
      ]
}


const getFocusValueIdx = computed(
    () => {
      const currentColor: string = matchedDisc.value.additional_value.toString()

      const coloredFocus = focusValueIdx[currentColor]

      let focusList = coloredFocus

      if (matchedDiscIdx.value) {
        if (!coloredFocus.includes(matchedDisc.value.idx)) {
          focusList = [
            matchedDisc.value.idx,
            ...coloredFocus.slice(0, -1)
          ]
        }
      }

      const availableFocus = finishVariantsOfDisc.value
          .map((v: any) => v.idx.toString())
          .filter((idx: string) => focusList.includes(idx))

      if (availableFocus.length < focusValueIdxCount) {
        const nextNonFocus = finishVariantsOfDisc.value
            .map((v: any) => v.idx.toString())
            .filter((idx: string) => !availableFocus.includes(idx))

        availableFocus.push(...nextNonFocus.slice(0, focusValueIdxCount - availableFocus.length))
      }

      return availableFocus

    }
)

const getFocusVariants = computed(() => {
  if (
      !discVariants.value.length ||
      !discVariants.value[activeDiscIdx.value] ||
      matchedDiscIdx.value === -1 ||
      !discVariants.value[activeDiscIdx.value].values ||
      !discVariants.value[activeDiscIdx.value].values[matchedDiscIdx.value]
  ) {
    return []
  }

  const currentColor: string = discVariants.value[activeDiscIdx.value].values[matchedDiscIdx.value].additional_value.toString()

  const coloredFocus = focusValueIdx[currentColor] || []
  const coloredAltFocus = focusAltValueIdx[currentColor] || []

  const currentDiscValues = discVariants.value[activeDiscIdx.value].values

  // go through the discVariants and return a list of the variants that have there idx in coloredFocus
  const focusVariants = currentDiscValues.filter((variant: any) =>
      coloredFocus.includes(variant.idx.toString())
  )

  // if focusVariants length is below 5, add the variants that have there id idx in coloredAltFocus
  if (focusVariants.length < 5) {
    const altVariants = currentDiscValues.filter(
        (variant: any) =>
            coloredAltFocus.includes(variant.idx.toString()) &&
            !focusVariants.some((fv: any) => fv.idx.toString() === variant.idx.toString())
    )
    focusVariants.push(...altVariants)
  }

  return focusVariants.slice(0, 5)
})

const nonFocusVariants = computed(() => {
  if (!finishVariantsOfDisc.value || !finishVariantsOfDisc.value.length) {
    return []
  }

  return finishVariantsOfDisc.value.filter(
      (variant: any) => !getFocusVariants.value.some((fv: any) => fv.idx.toString() === variant.idx.toString())
  )
})

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * tip texts
 */

const getTipTitle = computed(() => {
  if (hoverIdx.value != "") {
    const key = hoverIdx.value.toUpperCase() + "-" + hoverColor.value.toUpperCase()
    return t('components.parameters.tips.colorMetals.' + key + '.title')
  } else {
    return ''
  }
})

const getTipText = computed(() => {
  if (hoverIdx.value != "") {
    const key = hoverIdx.value.toUpperCase() + "-" + hoverColor.value.toUpperCase()
    return t('components.parameters.tips.colorMetals.' + key + '.text')
  } else {
    return ''
  }
})

const getTipImageUrl = computed(() => {
  if (hoverIdx.value != "") {
    const key = hoverIdx.value.toUpperCase() + "-" + hoverColor.value.toUpperCase()
    return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/metal/300x300/" + key + ".webp"
  } else {
    return ''
  }
})

onMounted(
    () => {
      setHoverIdx()
    }
)

/**
 * metal title
 */

const getMetalTitle = (idx: string, title: string, color: string) => {
  if (idx.startsWith("AU")) {
    return t('components.parameters.colorMetals.' + idx + '-' + color.toUpperCase())
  } else {
    return title
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemV3ParameterBox, {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
    "image-width-percent": imageWidthPercent,
    image: imageUrl.value,
    "header-image": getHeaderImage(),
    "header-image-srcset": getHeaderImage() + ' 300w, ' + getHeaderImage('1200x600') +' 600w',
    title: "Material",
    subtitle: currentDiscsMetalText.value || 'Wählen Sie das Material für Ihre Trauringe',
    loading: loading.value,
    "tip-title": getTipTitle.value,
    "tip-text": getTipText.value,
    "tip-image": getTipImageUrl.value
  }, {
    main: _withCtx(() => [
      (discVariants.value.length > 1)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
                style: _normalizeStyle(discSliderStyle.value)
              }, null, 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discVariants.value, (disc, discIdx) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: discIdx,
                  type: "button",
                  class: _normalizeClass(["text-[10px] tracking-wided relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", activeDiscIdx.value === discIdx ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                  onClick: ($event: any) => (activeDiscIdx.value = discIdx)
                }, " Scheibe " + _toDisplayString(discIdx + 1), 11, _hoisted_3))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(ItemV3MostSelected),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFocusVariants.value, (variantData, variantIdx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: variantIdx,
            class: _normalizeClass(["cursor-pointer flex flex-col py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] items-center justify-start", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
            onClick: ($event: any) => (handleValuePatch(activeDisc.value.idx, variantData)),
            onMouseover: ($event: any) => {hoverIdx.value = variantData.idx; hoverColor.value = variantData.additional_value},
            onMouseleave: _cache[0] || (_cache[0] = ($event: any) => {hoverIdx.value = matchedDisc.value.idx; hoverColor.value = matchedDisc.value.additional_value})
          }, [
            _createElementVNode("img", {
              src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/metal/300x300/${variantData.idx.toUpperCase()}-${variantData.additional_value.toUpperCase()}.webp`,
              srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/metal/600x600/${variantData.idx.toUpperCase()}-${variantData.additional_value.toUpperCase()}.webp`,
              class: "w-12 md:w-13 aspect-4:3 rounded-2xl"
            }, null, 8, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(getMetalTitle(variantData.idx, variantData.title, variantData.additional_value)), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$n(variantData.price, 'currency')), 1)
          ], 42, _hoisted_5))
        }), 128))
      ])
    ]),
    more: _withCtx(() => [
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonFocusVariants.value, (variantData, variantIdx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: variantIdx,
            class: _normalizeClass(["cursor-pointer flex flex-col py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] items-center justify-start", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
            onClick: ($event: any) => (handleValuePatch(activeDisc.value.idx, variantData)),
            onMouseover: ($event: any) => {hoverIdx.value = variantData.idx; hoverColor.value = variantData.additional_value},
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => {hoverIdx.value = matchedDisc.value.idx; hoverColor.value = matchedDisc.value.additional_value})
          }, [
            _createElementVNode("img", {
              src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/metal/300x300/${variantData.idx.toUpperCase()}-${variantData.additional_value.toUpperCase()}.webp`,
              srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/metal/600x600/${variantData.idx.toUpperCase()}-${variantData.additional_value.toUpperCase()}.webp`,
              class: "w-12 md:w-13 aspect-4:3 rounded-2xl"
            }, null, 8, _hoisted_11),
            _createElementVNode("span", _hoisted_12, _toDisplayString(getMetalTitle(variantData.idx, variantData.title, variantData.additional_value)), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$n(variantData.price, 'currency')), 1)
          ], 42, _hoisted_10))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["open", "image", "header-image", "header-image-srcset", "subtitle", "loading", "tip-title", "tip-text", "tip-image"]))
}
}

})